
import { LabelType } from '@/types/entities'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    boardLabels: {
      type: Array as () => Array<LabelType>,
      required: true
    },
    taskLabels: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      searchText: ''
    }
  },
  methods: {
    handleLabelClick (label: LabelType) {
      if (this.isTaskLabel(label._id)) this.$emit('removeLabel', label)
      else this.$emit('addLabel', label)
    },
    isTaskLabel (id: string): boolean {
      return this.taskLabels.includes(id)
    }
  }
})
